import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import s from './Navbar.module.css';

export default class Navbar extends Component {
  render() {
    return (
      <div className={s.Navbar}>
        <ul
          className="navbar-nav flex-column   navbar-sidenav"
          id="exampleAccordion"
        >
          <li
            className="nav-item"
            data-toggle="tooltip"
            data-placement="right"
            title="Dashboard"
          >
            <Link className="nav-link" to="/Patients">
              <i className="fas fa-procedures"></i>
              <span className="nav-link-text">&nbsp;&nbsp;Пациенты</span>
            </Link>
          </li>
          <li
            className="nav-item"
            data-toggle="tooltip"
            data-placement="right"
            title="Charts"
          >
            <Link className="nav-link" to="/patients-creator">
              <i className="fas fa-user-plus"></i>
              <span className="nav-link-text">&nbsp;&nbsp;Добавить запись</span>
            </Link>
          </li>
          <li
            className="nav-item"
            data-toggle="tooltip"
            data-placement="right"
            title="Tables"
          >
            <Link className="nav-link" to="/patients-statistic">
              <i className="fa fa-fw fa-table"></i>
              <span className="nav-link-text">&nbsp;&nbsp;Отчеты</span>
            </Link>
          </li>
          <li
            className="nav-item"
            data-toggle="tooltip"
            data-placement="right"
            title="Components"
          >
            <Link
              className="nav-link nav-link-collapse collapsed"
              data-toggle="collapse"
              to="#collapseComponents"
              data-parent="#exampleAccordion"
            >
              <i className="fa fa-fw fa-wrench"></i>
              <span className="nav-link-text">&nbsp;&nbsp;Настройки</span>
            </Link>
          </li>
          <li
            className="nav-item"
            data-toggle="tooltip"
            data-placement="right"
            title="Example Pages"
          >
            <Link
              className="nav-link nav-link-collapse collapsed"
              data-toggle="collapse"
              to="#collapseExamplePages"
              data-parent="#exampleAccordion"
            >
              <i className="fas fa-notes-medical"></i>
              <span className="nav-link-text">
                &nbsp;&nbsp;Больничные листы
              </span>
            </Link>
          </li>
          <li
            className="nav-item"
            data-toggle="tooltip"
            data-placement="right"
            title="Menu Levels"
          >
            <Link
              className="nav-link nav-link-collapse collapsed"
              data-toggle="collapse"
              to="/logout"
              data-parent="#exampleAccordion"
            >
              <i className="fas fa-user-md"></i>
              <span className="nav-link-text">&nbsp;&nbsp;Место прибытия</span>
            </Link>
          </li>
          <li
            className={`${s.active} ${'nav-item '}`}
            data-toggle="tooltip"
            data-placement="right"
            title="Link"
          >
            <Link className="nav-link" to="/Test">
              <i className="fa fa-fw fa-link"></i>
              <span className="nav-link-text">&nbsp;&nbsp;TEST</span>
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}
